import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const login = {
  methods: {
    //TODO:获取后端验证码
    async getCodeAn() {
      let res = await this.$http.get('/code');
      return res;
    },
    //登陆
    async login(userInfo) {

      let res = await this.$http.post("/auth/tenant/login", userInfo);
      console.log(res);
      if ( res.code == 200 ) {
        localStorage.setItem("user", JSON.stringify(res.data.user.safeTenantUser));
        localStorage.setItem("Authorization",`${res.data.access_token}`);
        // 本地保存token
        localStorage.setItem("tenantId",JSON.stringify(res.data.user.safeTenantUser.tenantId));
        //存到vuex
        this.$store.commit("uploginUser", res.data.user.safeTenantUser);
        this.$message({ message: "登陆成功!", type: "success" });
        this.$router.push("/");
        // TODO: WebSocket 通过单例模式连接ws服务器：
        const wsInstance = websocket.Instance;
        wsInstance.newvue = this;
        // TODO: WebSocket 将websocket挂载到vue原型上：
        Vue.prototype.$ws = wsInstance;
       
        Vue.prototype.MsgRouter = this.$router;
        // 连接WebSocket
        wsInstance.connect(res.data.user.safeTenantUser.id);   
      } else {
        this.$message.error(res.msg);
        // this.$hideLoading(); //关闭加载器
      }

      return res
    },
  },
};
